/**
 * Linking this account to the Telegram bot.
 *
 * All three act on whoever is signed in and take no user id: the server issues
 * a code to that user and records the chat that sends it back (see
 * server/telegram/userLink.js). The code is what proves the chat, because the
 * bot cannot be told whose it is — and cannot write to anyone who has not
 * written to it first.
 */

import { postJson } from "./jobsApi";

export function telegramStatus() {
  return postJson("user/telegramStatus", {});
}

export function telegramLinkCode() {
  return postJson("user/telegramLinkCode", {});
}

export function telegramUnlink() {
  return postJson("user/telegramUnlink", {});
}
